import { useEffect } from 'react';
import { configuration } from 'apis';

const useChecklistInitialLists = ({ setQuestionTypes, setProductServicesList, setTransactionTypesList, setDisciplines }) => {
    useEffect(() => {
        const fetchQuestionTypes = async () => {
            try {
                const res = await configuration.getQuestionTypes();
                if (Array.isArray(res)) {
                    setQuestionTypes(res);
                }
            } catch (err) {
                console.error('Failed to load question types', err);
            }
        };

        fetchQuestionTypes();
    }, [setQuestionTypes]);

    useEffect(() => {
        const fetchProductServices = async () => {
            try {
                const res = await configuration.getProductServices();
                setProductServicesList(res);
            } catch (err) {
                console.error('Failed to load product services:', err);
            }
        };

        fetchProductServices();
    }, [setProductServicesList]);

    useEffect(() => {
        const fetchTransactionTypes = async () => {
            try {
                const res = await configuration.getTransactionTypes();
                setTransactionTypesList(res);
            } catch (err) {
                console.error('Failed to fetch transaction types', err);
            }
        };

        fetchTransactionTypes();
    }, [setTransactionTypesList]);

    useEffect(() => {
        const fetchDisciplines = async () => {
            try {
                const res = await configuration.getDisciplines();
                if (Array.isArray(res)) {
                    setDisciplines(res);
                }
            } catch (err) {
                console.error('Failed to load disciplines:', err);
            }
        };

        fetchDisciplines();
    }, [setDisciplines]);

    useEffect(() => {
        const fetchData = async () => {
            const data = await configuration.getProductServices();
            setProductServicesList(data.map((p) => ({ ...p, isNew: false, isDeleted: false })));
        };

        fetchData();
    }, [setProductServicesList]);
};

export default useChecklistInitialLists;
